import {Component, Input, Output, EventEmitter, inject} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import {Router} from "@angular/router";
import {CropService, FirmService} from '@6grain/masofa-monolith-api-client/dictionaries';
import {
  ModalEditSeasonMap
} from '@app/pages/electronic-field-map/pages/fields/passport/forms/modal-edit-season-map/modal-edit-season-map';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import {CropCacheService} from '@services/caches/crop-cache.service';

@Component({
  selector: 'app-season-details-dialog',
  standalone: true,
  imports: [CommonModule, TranslateModule, DialogModule, ButtonModule],
  templateUrl: './season-details-dialog.component.html',
  styleUrls: ['./season-details-dialog.component.scss'],
  providers:[DatePipe]
})
export class SeasonDetailsDialogComponent {


  public  visible: boolean = false;
  private router = inject(Router);
  private dialogService = inject(DialogService);
  private translate = inject(TranslateService);
  private cropCache = inject(CropCacheService);

  @Input() season: any | null = null;
  @Input() appendTo?: string;
  @Output() close = new EventEmitter<void>();
  @Output() save = new EventEmitter<void>();



  show(season: any): void {
    this.season = season;
    this.visible = true;
  }

  onHide(): void {
    this.visible = false;
    this.close.emit();
  }

  /** Ground follow-up flag from API (`monitoring` or `isMonitoring`). */
  seasonIsMonitoring(seasonLike: any): boolean {
    return !!(seasonLike?.monitoring ?? seasonLike?.isMonitoring);
  }

  /** Planned crop label (crop cache lookup, consistent with map popups). */
  plannedCropDisplay(seasonLike: any): string {
    if (!seasonLike) {
      return '';
    }
    if (seasonLike.plannedCropName != null && String(seasonLike.plannedCropName).length) {
      return String(seasonLike.plannedCropName);
    }
    const pid = seasonLike.plannedCropId as string | undefined;
    if (!pid) {
      return '';
    }
    return this.cropCache.getCropNameById(String(pid), true) ?? String(pid);
  }

  onShowMore(): void {
    const fieldId = this.season?.field?.id || this.season?.fieldId || this.season?.id;
    if (!fieldId) {
      return;
    }

    try {
      this.close.emit();
      if (this.router && typeof this.router.navigate === 'function') {
        this.router.navigate(['/electronic-field-map/fields', fieldId, 'history']);
      } else {
        window.location.href = `/electronic-field-map/fields/${fieldId}/general/history`;
      }
    } catch (err) {
      console.warn('Error navigating to field details', err);
    }
  }


  onEdit(): void {
    try {
      const model = this.season;
      const dataForModal = this.dialogService.open(ModalEditSeasonMap, {
        header: this.translate.instant('Crop information'),
        width: '90%',
        height: '92%',
        closable: true,
        modal: true,
        data: {
          crops: [],
          field: model?.id || null,
          model: model,
        }
      });

      dataForModal.onClose.subscribe((result: any) => {
        if (result?.success) {
          this.visible = false;
          this.save.emit();
        }
      });
    } catch (err) {
      console.error('Failed to open edit modal', err);
    }
  }
}
